export const DEPENDENCY_UPDATE_EVENT = 'form:dependency-update'
